import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.6665 11.3334L11.3332 4.66675M11.3332 4.66675H5.33317M11.3332 4.66675V10.6667",
		stroke: "#1E88E5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowUpRight;
